<template>
    <div class="my-number flex justify-center align-center">
        <div>当前算力</div>
        <div
            v-for="(item, i) in showNumber"
            :key="'showNumber' + i"
            class="flex number-content align-center">
            <div
                v-for="(num, x) in item"
                :key="'num' + x"
                class="flex number-box justify-center align-center">
                {{ num }}
            </div>
            <div
                v-if="i != showNumber.length - 1"
                class="number-unit flex flex-direction align-center">
                <span class="separat">,</span>
                <span class="unit">{{ unit[i] }}</span>
            </div>
        </div>
        <div>次/秒</div>
    </div>
</template>

<script>
let numberUnit = ['P', 'T', 'G', 'M', 'K']
import { dataInterface } from '@/api/dataInterfaceApi';
export default {
    // props: {
    //     number: {
    //         type: [String, Number],
    //         default: '12345678901'
    //     }
    // },
    data() {
        return {
            unit: [],
            showNumber: [],
            timer: null
        }
    },
    async mounted() {
        await this.selectComprehensiveSituation()
        this.timer = setInterval(()=>{
            this.selectComprehensiveSituation()
        }, 3000)
    },
    methods: {
        setNumber() {
            let numnber =  String(this.number)
            this.showNumber = numnber.split('').reverse().join('').match(/(\d{1,3})/g).reverse().map(item => {
                return item.split('').reverse()
            }) || []
            console.log('this.showNumber:======', this.showNumber)
            this.unit = JSON.parse(JSON.stringify(numberUnit)).reverse().splice(0, this.showNumber.length - 1).reverse()
            console.log('this.unit:======', this.unit)
            let maxL = this.showNumber.length - this.unit.length
            if(maxL > 0) {
                let oneA = []
                for(let x = 0; x < maxL - 1; x++) {
                    // oneA.push(showNumber[x])
                    this.unit.unshift('')
                }
                // this.showNumber = [oneA.flat(2), ...showNumber.splice(0, maxL)]
            }
            // debugger
            // console.log('tem', temp)
        },
        selectComprehensiveSituation(data={}){ 
            let _this = this;
            let params = { 
                enCode: 'computingpower-mid-dqsl',
            }
            dataInterface
            .dataFaceApi(params)
            .then((res) => {
                if(!res) return;
                console.log(res[0], '=====当前算力1')
                let { current_power } = res[0] || {}
                this.number = current_power
                this.setNumber()
            })
            .catch((err) => {
                console.log(err);
            });
        },
    },
    destroyed () {
        console.log('destroyed')
        clearInterval( this.timer )
    },
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.my-number {
    width: 100%;
    font-size: $FontSize40;
    height: 140px;
    > div {
        margin: 0 20px;
    }
    .number-content {
        margin: 0;
    }
    .number-box {
        width: 70px;
        height: 76px;
        font-size: $FontSize76;
        @include ffamily-DS;
        color: #00FDF4;
        background: url(~@/assets/images/computility/monitor-icon13.png) no-repeat;
        background-size: 100% 100%;
        margin: 0 10px;
    }
    .number-unit {
        position: relative;
        width: 0;
        height: 76px;
        padding-top: 30px;
        .separat {
            font-size: $FontSize60;
            line-height: 60px;
        }
        .unit {
            font-size: $FontSize24;
        }
    }
}
</style>